/* Clima product card swatch discovery + in-place colour swap.
   Extracted from snippets/product-card-clima.liquid; loaded once via theme.liquid. */
    if (!window._pccAutoSwatchesReady) {
      window._pccAutoSwatchesReady = true;

      var _pccColorMap = [
        { keys: ['strieborn','silver'],                 bg: 'linear-gradient(135deg,#e8e8e8 0%,#b0b0b0 30%,#d8d8d8 50%,#a8a8a8 70%,#c8c8c8 100%)' },
        { keys: ['čiern','ciern','black'],              bg: '#1a1a1a' },
        { keys: ['biel','white'],                       bg: '#f0f0f0' },
        { keys: ['červen','cerven','red'],              bg: '#d61116' },
        { keys: ['modrý textil','modry textil'],        bg: '#1a5c9e' },
        { keys: ['modr','blue'],                        bg: '#1565c0' },
        { keys: ['béžov','bezov','beige'],              bg: '#d4b483' },
        { keys: ['tmavé drevo','tmave drevo'],          bg: 'linear-gradient(135deg,#5c3d1e 0%,#3b2010 100%)' },
        { keys: ['svetlé drevo','svetle drevo'],        bg: 'linear-gradient(135deg,#c49a6c 0%,#a0784a 100%)' },
        { keys: ['sivý textil','sivy textil'],          bg: '#8a8a8a' },
        { keys: ['sivý','sivy','grey','gray'],          bg: '#9e9e9e' },
        { keys: ['zelen','green'],                      bg: '#2e7d32' },
        { keys: ['ružov','ruzov','pink'],               bg: '#e91e8c' },
      ];
      var _pccColorLetterMap = [
        { keys: ['čiern','ciern','black'],  letter: 'B' },
        { keys: ['biel','white'],           letter: 'W' },
        { keys: ['strieborn','silver'],     letter: 'S' },
        { keys: ['červen','cerven','red'],  letter: 'R' },
        { keys: ['sivý','sivy','grey','gray'], letter: 'G' },
      ];

      function _pccGetBg(title) {
        var t = title.toLowerCase();
        for (var i = 0; i < _pccColorMap.length; i++)
          for (var j = 0; j < _pccColorMap[i].keys.length; j++)
            if (t.indexOf(_pccColorMap[i].keys[j]) !== -1) return _pccColorMap[i].bg;
        return '#cccccc';
      }

      function _pccGetLetter(colorWord) {
        var c = colorWord.toLowerCase();
        for (var i = 0; i < _pccColorLetterMap.length; i++)
          for (var j = 0; j < _pccColorLetterMap[i].keys.length; j++)
            if (c.indexOf(_pccColorLetterMap[i].keys[j]) !== -1) return _pccColorLetterMap[i].letter;
        return null;
      }

      // Canonical colour identity for a product, scanned from its full title.
      // Collapses spelling/diacritic variants (čiern/ciern/black → same key) so
      // shape/feature words (kruh vs štvorec) never count as a colour difference.
      function _pccColorKey(title) {
        var t = title.toLowerCase();
        for (var i = 0; i < _pccColorMap.length; i++)
          for (var j = 0; j < _pccColorMap[i].keys.length; j++)
            if (t.indexOf(_pccColorMap[i].keys[j]) !== -1) return 'c' + i;
        return null;
      }

      // Human-readable colour word from the title (for the swatch tooltip).
      function _pccColorWord(title) {
        var words = title.trim().split(/\s+/);
        for (var w = 0; w < words.length; w++) {
          var lw = words[w].toLowerCase();
          for (var i = 0; i < _pccColorMap.length; i++)
            for (var j = 0; j < _pccColorMap[i].keys.length; j++)
              if (lw.indexOf(_pccColorMap[i].keys[j]) !== -1) return words[w];
        }
        return '';
      }

      // Model code with an optional trailing colour-suffix letter stripped
      // (Daikin FTXA50C[S|W|B] → FTXA50C). Codes not ending in a colour letter
      // (e.g. Samsung …PKG/EU) are returned unchanged. This makes a sibling
      // "same product, different colour" and never a different capacity:
      // FTXA50 vs FTXA20 and AC140 vs AC120 differ in the base, so are excluded.
      // Two model codes are colour-twins when they are identical (colour lives only
      // in the title — e.g. Samsung cassettes share one code) or the same length and
      // differ in exactly one *letter* position. Handles every layout seen in the
      // catalogue: FTXA50C[B/S/W], FTXJ50A[B/S]9, AR70H07C1A[B/W]NEU, panel PC4N[U/B]NMAN.
      // A single differing *digit* is a capacity change, not a colour, so it's excluded.
      function _pccCodesSibling(a, b) {
        if (a === b) return true;
        if (a.length !== b.length) return false;
        var diff = -1;
        for (var i = 0; i < a.length; i++) {
          if (a.charAt(i).toUpperCase() !== b.charAt(i).toUpperCase()) {
            if (diff !== -1) return false; // more than one difference
            diff = i;
          }
        }
        if (diff === -1) return true;
        return /[A-Za-z]/.test(a.charAt(diff)) && /[A-Za-z]/.test(b.charAt(diff));
      }

      // Descriptive search query: the title with the colour word and the model code
      // removed. Colour twins share this string, so searching by it returns the other
      // colours even when the colour is not encoded in the code (Samsung cassettes/panels).
      function _pccDescQuery(title, modelCode) {
        var t = ' ' + title + ' ';
        var word = _pccColorWord(title);
        if (word) t = t.replace(' ' + word + ' ', ' ');
        t = t.replace(' ' + modelCode + ' ', ' ');
        return t.replace(/\s+/g, ' ').trim();
      }

      function _pccRender(container, siblings, productTitle, productId) {
        var placeholder = container.querySelector('.pcc-swatch-placeholder');
        var card = container.closest('.pcc-card');

        // Current ("home") colour data is read live from the card so clicking
        // back to it restores the original image/title/price.
        var curImgEl = card && card.querySelector('.pcc-img');
        var curTitleEl = card && card.querySelector('.pcc-title');
        var curPriceEl = card && card.querySelector('.pcc-price');

        // Build deduped colour groups (current product first). Grouping by the
        // canonical colour means multiple shape/feature variants of the same
        // colour collapse into a single swatch.
        var currentKey = _pccColorKey(productTitle) || 'current';
        var groups = {}, order = [];
        groups[currentKey] = {
          url: container.dataset.productUrl, bg: _pccGetBg(productTitle),
          label: _pccColorWord(productTitle), active: true,
          img: curImgEl ? (curImgEl.currentSrc || curImgEl.src) : '',
          title: curTitleEl ? curTitleEl.textContent.trim() : '',
          price: curPriceEl ? curPriceEl.textContent.trim() : ''
        };
        order.push(currentKey);

        siblings.forEach(function(sib) {
          var key = _pccColorKey(sib.title);
          if (key && !groups[key]) {
            var sibImg = (sib.featured_image && sib.featured_image.url) || sib.image || '';
            groups[key] = {
              url: sib.url, bg: _pccGetBg(sib.title), label: _pccColorWord(sib.title),
              active: false, img: sibImg, title: sib.title, price: ''
            };
            order.push(key);
          }
        });

        if (order.length < 2) return; // no siblings found, leave placeholder

        if (placeholder) placeholder.remove();
        order.forEach(function(key) {
          var g = groups[key];
          var a = document.createElement('a');
          a.href = g.url;
          a.className = 'pcc-swatch-dot' + (g.active ? ' pcc-swatch-dot--active' : '');
          a.title = g.label;
          a.setAttribute('aria-label', g.label);
          var bgProp = g.bg.indexOf('gradient') !== -1 ? 'background' : 'background-color';
          a.style.cssText = bgProp + ':' + g.bg + ';';
          // Data for the in-place swap handler (_pccSwatchSwapReady).
          a.dataset.pccImg = g.img || '';
          a.dataset.pccUrl = g.url;
          if (g.title) a.dataset.pccTitle = g.title;
          if (g.price) a.dataset.pccPrice = g.price;
          container.appendChild(a);
        });
      }

      function _pccRunAll() {
        var containers = document.querySelectorAll('.pcc-swatches[data-pcc-auto]:not([data-pcc-done])');
        if (!containers.length) return;

        // Group containers by search query to minimise API calls
        var byQuery = {};
        containers.forEach(function(c) {
          c.setAttribute('data-pcc-done', '1'); // mark processed so grid re-renders don't refetch
          var title = c.dataset.productTitle || '';
          var words = title.trim().split(/\s+/);
          if (words.length < 3) return;
          var modelCode = words[words.length - 1];
          if (!modelCode || !/\d/.test(modelCode)) return;
          // Prefer a targeted code-prefix query: find the colour letter (from the
          // title's colour word) inside the code and search by the stem before it.
          var colourWord = _pccColorWord(title);
          var letter = colourWord ? _pccGetLetter(colourWord) : null;
          var query = null;
          if (letter) {
            var pos = modelCode.toUpperCase().lastIndexOf(letter);
            if (pos >= 4) query = modelCode.slice(0, pos);
          }
          // Otherwise the colour isn't encoded in the code (Samsung cassettes/panels —
          // colour is only in the title) — search by the descriptive name instead.
          if (!query) query = _pccDescQuery(title, modelCode);
          if (!query) return;
          if (!byQuery[query]) byQuery[query] = [];
          byQuery[query].push({ container: c, title: title, modelCode: modelCode });
        });

        Object.keys(byQuery).forEach(function(query) {
          var cards = byQuery[query];
          fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=20')
            .then(function(r) { return r.json(); })
            .then(function(data) {
              var products = (data.resources && data.resources.results && data.resources.results.products) || [];
              cards.forEach(function(card) {
                var cardColor = _pccColorKey(card.title);
                var siblings = products.filter(function(p) {
                  var pw = p.title.trim().split(/\s+/);
                  var pm = pw[pw.length - 1];
                  // Colour-twin code (identical, or one differing letter) …
                  if (!_pccCodesSibling(pm, card.modelCode)) return false;
                  // … and a genuinely different colour. Same-colour shape/feature
                  // variants share the colour key (deduped in render); capacity
                  // changes differ by a digit and are excluded by the twin test.
                  var pColor = _pccColorKey(p.title);
                  return pColor && cardColor && pColor !== cardColor;
                });
                _pccRender(card.container, siblings, card.title, card.container.dataset.productId);
              });
            })
            .catch(function() {});
        });
      }

      function _pccSchedule() {
        clearTimeout(window._pccT);
        window._pccT = setTimeout(_pccRunAll, 120);
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', _pccRunAll);
      } else {
        _pccRunAll();
      }
      // Re-run after the grid is re-rendered (filtering, pagination, dev hot-reload).
      // Processed cards are flagged data-pcc-done, so this only handles fresh ones.
      new MutationObserver(_pccSchedule).observe(document.body, { childList: true, subtree: true });
    }

    /* In-place colour swap: clicking a colour swatch rebuilds the card (image +
       title + price + availability + links) instead of navigating to that colour's
       product page. One delegated listener per page; works for cards added later by
       AJAX filtering / pagination. The <a href> stays a no-JS / new-tab fallback. */
    if (!window._pccSwatchSwapReady) {
      window._pccSwatchSwapReady = true;

      // Build crisp responsive sources for a Shopify CDN image URL. Used when a
      // colour swatch swaps the card image in place — keeps it sharp on retina
      // (matching the static markup's srcset/sizes) instead of pinning one low-res src.
      var _PCC_SIZES = '(min-width: 990px) 30vw, (min-width: 640px) 45vw, 100vw';
      var _PCC_WIDTHS = [300, 500, 700, 900, 1100, 1400];
      function _pccImgWidth(u, w) {
        if (!u) return u;
        return /[?&]width=\d+/.test(u)
          ? u.replace(/([?&]width=)\d+/, '$1' + w)
          : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
      }
      function _pccImgSrcset(u) {
        return _PCC_WIDTHS.map(function (w) { return _pccImgWidth(u, w) + ' ' + w + 'w'; }).join(', ');
      }

      // Lazily copy the card's current ("home") values onto the active swatch the first
      // time it's needed, so switching to another colour and back restores the original.
      function _pccBackfillActive(card) {
        var active = card.querySelector('.pcc-swatch-dot--active');
        if (!active || active.dataset.pccImg) return;
        var img = card.querySelector('.pcc-img');
        var title = card.querySelector('.pcc-title');
        var price = card.querySelector('.pcc-price');
        var avail = card.querySelector('.pcc-availability');
        active.dataset.pccImg = img ? (img.currentSrc || img.src || '') : '';
        active.dataset.pccUrl = (title && title.getAttribute('href')) || active.getAttribute('href') || '';
        if (title) active.dataset.pccTitle = title.textContent.trim();
        if (price) active.dataset.pccPrice = price.textContent.trim();
        if (avail) active.dataset.pccAvail = avail.classList.contains('pcc-availability--out') ? '0' : '1';
      }

      document.addEventListener('click', function (e) {
        var dot = e.target.closest && e.target.closest('.pcc-swatch-dot[data-pcc-img]');
        if (!dot) return;
        // Let new-tab / modified clicks fall through to the href.
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        var card = dot.closest('.pcc-card');
        if (!card) return;
        e.preventDefault();
        _pccBackfillActive(card);

        var url = dot.dataset.pccUrl || dot.getAttribute('href');

        // Image
        var img = card.querySelector('.pcc-img');
        if (img && dot.dataset.pccImg) {
          img.src = _pccImgWidth(dot.dataset.pccImg, 1100);
          img.srcset = _pccImgSrcset(dot.dataset.pccImg);
          img.sizes = _PCC_SIZES;
          if (dot.dataset.pccTitle) img.alt = dot.dataset.pccTitle;
        }

        // Links — point everything that opens the product at the chosen colour.
        if (url) {
          ['.pcc-image-link', '.pcc-title', '.pcc-cta', 'a.pcc-action'].forEach(function (sel) {
            var el = card.querySelector(sel);
            if (el) el.setAttribute('href', url);
          });
        }

        // Text
        if (dot.dataset.pccTitle) {
          var t = card.querySelector('.pcc-title');
          if (t) t.textContent = dot.dataset.pccTitle;
        }
        if (dot.dataset.pccPrice) {
          var pr = card.querySelector('.pcc-price');
          if (pr) pr.textContent = dot.dataset.pccPrice;
        }
        if (dot.dataset.pccAvail === '0' || dot.dataset.pccAvail === '1') {
          var av = card.querySelector('.pcc-availability');
          if (av) {
            var inStock = dot.dataset.pccAvail === '1';
            av.textContent = inStock ? 'Skladom' : 'Nie je skladom';
            av.classList.toggle('pcc-availability--in', inStock);
            av.classList.toggle('pcc-availability--out', !inStock);
          }
        }

        // Favourites button — so "Obľúbené" saves the colour that's on screen.
        var fav = card.querySelector('.pcc-action[data-fav-id]');
        if (fav) {
          if (url) fav.setAttribute('data-fav-url', url);
          if (dot.dataset.pccImg) fav.setAttribute('data-fav-image', dot.dataset.pccImg);
          if (dot.dataset.pccTitle) fav.setAttribute('data-fav-title', dot.dataset.pccTitle);
          if (dot.dataset.pccPrice) fav.setAttribute('data-fav-price', dot.dataset.pccPrice);
          if (dot.dataset.pccAvail === '0' || dot.dataset.pccAvail === '1')
            fav.setAttribute('data-fav-available', dot.dataset.pccAvail === '1' ? 'true' : 'false');
        }

        // Compare button — so "Porovnať" picks the selected colour.
        var cmp = card.querySelector('.pcc-action[data-compare-id]');
        if (cmp) {
          if (url) cmp.setAttribute('data-compare-url', url);
          if (dot.dataset.pccImg) {
            cmp.setAttribute('data-compare-image', dot.dataset.pccImg);
            cmp.setAttribute('data-compare-image-lg', dot.dataset.pccImg);
          }
          if (dot.dataset.pccTitle) cmp.setAttribute('data-compare-title', dot.dataset.pccTitle);
          if (dot.dataset.pccPrice) cmp.setAttribute('data-compare-price', dot.dataset.pccPrice);
          if (dot.dataset.pccAvail === '0' || dot.dataset.pccAvail === '1')
            cmp.setAttribute('data-compare-available', dot.dataset.pccAvail === '1' ? 'true' : 'false');
        }

        // Active ring
        var dots = card.querySelectorAll('.pcc-swatch-dot');
        for (var i = 0; i < dots.length; i++) dots[i].classList.remove('pcc-swatch-dot--active');
        dot.classList.add('pcc-swatch-dot--active');
      }, false);
    }
    
